import { Show, TabbedShowLayout, Tab, useShowController, Loading } from 'react-admin';

import { OfferOrderAccountSummaryTab } from './OfferOrderAccountSummaryTab';
import { OfferOrderActions } from './OfferOrderActions';
import { OfferOrderDetailsTab } from './OfferOrderDetailsTab';

export const OfferOrderShow = () => {
  const { isLoading } = useShowController();

  if (isLoading) return <Loading />;

  return (
    <Show emptyWhileLoading title={'Offer Order Details'} actions={<OfferOrderActions />}>
      <TabbedShowLayout>
        <Tab label='Offer Order Information'>
          <OfferOrderDetailsTab />
        </Tab>
        <Tab label='Account Summary'>
          <OfferOrderAccountSummaryTab />
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};
